// Widget 配置檔案
// 定義所有可用的 widgets

import LowStockWidget from './widgets/LowStockWidget';
import PendingOrdersWidget from './widgets/PendingOrdersWidget';
import TodayInboundsWidget from './widgets/TodayInboundsWidget';

// Widget 類型定義
export const WIDGET_TYPES = {
  PENDING_ORDERS: 'pending_orders',
  TODAY_INBOUNDS: 'today_inbounds',
  LOW_STOCK: 'low_stock',
};

// 可用的 Widgets 清單（Widget 庫）
export const AVAILABLE_WIDGETS = [
  {
    id: WIDGET_TYPES.PENDING_ORDERS,
    name: 'operator.dashboard.widgets.pending_orders.name',
    description: 'operator.dashboard.widgets.pending_orders.description',
    component: PendingOrdersWidget,
    defaultSize: { xs: 24, sm: 12, md: 8, lg: 6 },
  },
  {
    id: WIDGET_TYPES.TODAY_INBOUNDS,
    name: 'operator.dashboard.widgets.today_inbounds.name',
    description: 'operator.dashboard.widgets.today_inbounds.description',
    component: TodayInboundsWidget,
    defaultSize: { xs: 24, sm: 12, md: 8, lg: 6 },
  },
  {
    id: WIDGET_TYPES.LOW_STOCK,
    name: 'operator.dashboard.widgets.low_stock.name',
    description: 'operator.dashboard.widgets.low_stock.description',
    component: LowStockWidget,
    defaultSize: { xs: 24, sm: 12, md: 8, lg: 6 },
  },
];

// 預設 Dashboard 配置
export const DEFAULT_DASHBOARD_CONFIG = [
  {
    id: WIDGET_TYPES.PENDING_ORDERS,
    position: 0,
  },
];

// 根據 ID 獲取 Widget 配置
export const getWidgetById = (id) => {
  return AVAILABLE_WIDGETS.find(widget => widget.id === id);
};
